import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSF Vessels API
 */
export const wsfVesselsApiMeta: ApiMeta = {
  name: "wsf-vessels",
  baseUrl: "https://www.wsdot.wa.gov/ferries/api/vessels/rest",
};
